// removed by extract-text-webpack-plugin
module.exports = {"hidden":"_3tR-c","visuallyhidden":"_2PfeY","hide-text":"_1p43v","center":"_3Rlye","noprint":"_37Jlb","root":"_-_Vfy","leadText":"_2vpHP _-_Vfy _25KE7"};


/*****************
 ** WEBPACK FOOTER
 ** ./themes/ui-lead-text/styles/default.scss
 ** module id = 1010
 ** module chunks = 2
 **/